import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 4.25A2.25 2.25 0 0 1 10.25 2h3.5A2.25 2.25 0 0 1 16 4.25V5h3.999a.75.75 0 0 1 0 1.5H19.5v13.25A2.25 2.25 0 0 1 17.25 22H6.75a2.25 2.25 0 0 1-2.25-2.25V6.5H4A.75.75 0 0 1 4 5h4zm10 11.646V6.5H6v13.25c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75zM9.5 5h5v-.75a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75zm.5 4.75a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75m4.75.75a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }